import { Button, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import "../company/company.css";
import SettingsProgMain from "./settings-prog-main";
import SettingsProgLicenses from "./settings-prog-licenses";
import SettingsProgPrices from "./settings-prog-prices";
import "./settings-prog.css";

const SettingsProg = ({ progId, onClose }) => {
  const isMobile = useViewportBreakpoint() === "mobile";
  const handleClose = refresh => onClose(refresh);

  const items = [
    {
      key: "program",
      label: "Программа",
      children: <SettingsProgMain progId={progId} onClose={handleClose} isMobile={isMobile} />,
    },
    {
      key: "licenses",
      label: "Виды лицензий",
      children: <SettingsProgLicenses progId={progId} />,
    },
    {
      key: "prices",
      label: "Цены",
      children: <SettingsProgPrices progId={progId} />,
    },
  ];

  if (isMobile) {
    return (
      <div
        className="misoft-modal-overlay company-base-overlay--mobile settings-prog-mobile-overlay"
        onClick={e => e.target === e.currentTarget && handleClose(false)}
      >
        <div
          className="misoft-modal-content company-base-sheet--mobile settings-prog-mobile-panel"
          onClick={e => e.stopPropagation()}
        >
          <div className="company-base-sheet-header">
            <span className="company-base-sheet-title">Программа #{progId}</span>
            <Space size="small" className="company-base-sheet-actions">
              <Button
                type="default"
                icon={<CloseOutlined />}
                onClick={() => handleClose(false)}
                aria-label="Закрыть"
                className="company-base-header-icon-btn"
              />
            </Space>
          </div>
          <div className="company-base-sheet-body settings-prog-mobile-body">
            <MultiPane items={items} type="card" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="cloud-modal-overlay" onClick={() => handleClose(false)} />
      <div className="cloud-modal-license-order-keys" style={{ maxWidth: "90%" }}>
        <div className="cloud-modal-header">
          <h3>Программа #{progId}</h3>
          <Button onClick={() => handleClose(false)} type="text">
            ×
          </Button>
        </div>
        <div className="cloud-modal-content">
          <MultiPane items={items} type="card" />
        </div>
      </div>
    </>
  );
};

export default SettingsProg;
